import { format, getUnixTime } from 'date-fns';

export default {
  set_groups: function(ev, groups) {
    groups = groups || [];
    ev.groups = [];
    ev.ghash = {};
    groups.forEach(function(g) {
      if (!g.name) { return; }
      g.dname = g.name.split('-')[1];
      ev.ghash[g.name] = g;
      ev.groups.push(g);
    });
  },
  new_id: function(ev) {
    let tm = Date.now()/100;
    let id = "";
    while (tm > 0) {
      id = window.vx_fake62(tm) + id;
      tm = Math.trunc(tm / 62);
    }
    id = id + window.vx_fake62(62*Math.random());
    return id;
  },
  event_modified: function(ev) {
    if (ev.ver && !ev.pver) { ev.pver = ev.ver; }
    ev.ver = (ev.ver || 0)+1;
  },
  session_modified: function(ev, ss) {
    if (ss.ver && !ss.pver) { ss.pver = ss.ver; }
    ss.ver = (ss.ver || 0)+1;
  },
  remote_to_local: function(event) {
    var ev = event;
    var allsessions = event.sessions || [];
    let util = this;
    //console.log("allsessions:"+JSON.stringify(allsessions));
    ev.sessions = [];
    if (!ev.stages) ev.stages = [];
    if (!ev.booths) ev.booths = [];
    if (!ev.networking) ev.networking = [];
    if (!ev.sponsors) ev.sponsors = [];
    if (!ev.email_reg) ev.email_reg = {};
    ev.speakers = [];

    allsessions.forEach(function(s) {
      delete s.pver;
      if (s.speakers) {
        s.speakers.forEach(function(speaker) {
          ev.speakers.push(speaker);
        });
      }
      //if (s.moderators) {
      //  s.moderators.forEach(function(mod) {
      //  });
      //}
      if (s.kind == 'session') {
	ev.sessions.push(s);
      } else if (s.kind == 'stage') {
	ev.stages.push(s);
      } else if (s.kind == 'booth') {
	ev.booths.push(s);
      } else if (s.kind == 'networking') {
	ev.networking.push(s);
      }
    });
    this.set_groups(ev, ev.groups);
    //ev.delta = true;
    return ev;
  },
  local_to_remote: function(ev) {
        var event = {};
        event.acc = ev.acc;
        event.id = ev.id;
        event.ver = ev.ver;
        event.pver = ev.pver;
        event.name = ev.name;
        event.descr = ev.descr;
        event.banner = ev.banner;
	event.logo = ev.logo;
        event.startep = ev.startep;
        event.endep = ev.endep;
	event.is_pub = ev.is_pub;
	event.email_reg = ev.email_reg;
        event.sessions = ev.sessions.concat(ev.stages, ev.booths, ev.networking);
        event.sponsors = ev.sponsors;
        event.coord = ev.coord;
        event.delta = ev.delta;
        return event;
  },
  room_dname: function(ev, roomname) {
    let name;
    ev.stages.forEach(function(s) {
      if (s.roomname == roomname) {
        name = "Stage:"+s.name;
      }
    });
    if (name) {return name;}
    
    ev.booths.forEach(function(s) {
      if (s.roomname == roomname) {
        name = "Booth:"+s.title;
      }
    });
    if (name) {return name;}
    
    ev.networking.forEach(function(s) {
      if (s.roomname == roomname) {
          name = "Net:"+s.title;
      }
    });
    if (name) {return name;}
  },
  datestring: function(item) {
    if (!item || !item.startep) return '';
    var date1 = new Date(item.startep);
    var date2 = new Date(item.endep);
    let sdate = format(date1,'MM/dd E h:mma');
    let edate;
    if (((item.endep - item.startep) < 24*3600*1000) &&
        date1.getDay() == date2.getDay()) {
      edate = format(date2,'h:mma');
    } else {
      edate = format(date2,'MM/dd E h:mma');
    }
    return (sdate+" - "+edate);
  },
  ep2str: function(ep) {
    let date1 = new Date(ep);
    return format(date1,'MM/dd E h:mma');
  },
  session_status: function(ev,session) {
    let now = Date.now();
    if (!session.startep) {
      session.startep = ev.startep;
    }
    if (!session.endep) {
      session.endep = ev.endep;
    }    
    if (now > session.endep) {
      return "ended";
    } else if (now >= session.startep) {
      return "active";
    } else if (now >= session.startep - 300000) {
      return "soon";
    } 
    return "future";
  },
  getBannerName: function(item) {
      if (!item || item.banner === undefined) return '';
      var arr = item.banner.split("/");
      var name = arr[arr.length-1];
      return (name != "stars-1194599.jpg") ? name: '';
  },
  getLogoName: function(item) {
      if (!item || item.logo === undefined) return '';
      var arr = item.logo.split("/");
      var name = arr[arr.length-1];
      return name;
  },
  openbio: function(url) {
      if (url != '') {
          if (!url.match(/^https?:\/\//i)) {
              url = 'http://' + url;
              }
          window.open(url, '_blank');
      }
  },
  abridgeDescr: function(ev) {
     if (ev.descr) {
       if (ev.descr.length > 500) {
          let d = ev.descr.slice(0,490);
          let sp = d.lastIndexOf(" ");
          /* Split at a space if near the end */
          if (sp > 450) {
             d = d.slice(0,sp);
          }
          return d + "...";
       } else {
          return ev.descr;
       }
     } else {
       return "No description provided.";
     }
  }
}
